import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

import { nextTick, onMounted, ref, watch } from "vue";

type Point = {
  id: number;
  x: number;
  y: number;
  initialX: number;
  initialY: number;
  initialOpacity: number;
  initialScale: number;
  color: string;
  delay: string;
};

const GRID_SIZE = 12;
const GRID_DIMENSION = 160; // The size of the final ordered grid in pixels


export default /*@__PURE__*/_defineComponent({
  __name: 'StepThreeAnimation',
  props: {
    isHovering: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const points = ref<Point[]>([]);
const containerRef = ref<HTMLElement | null>(null);
const colors = ["bg-red-400", "bg-orange-400", "bg-blue-200", "bg-green-200", "bg-green-500"];

const animatePoints = (isHovering: boolean) => {
  if (isHovering) {
    // Hover logic can be added here if needed in the future
  } else {
    // Un-hover logic
  }
};

watch(
  () => props.isHovering,
  (newValue) => {
    animatePoints(newValue);
  },
);

onMounted(() => {
  nextTick(() => {
    if (containerRef.value) {
      const { offsetWidth, offsetHeight } = containerRef.value;
      const newPoints: Point[] = [];
      const dotSize = 10; // from w-2.5 h-2.5 -> 0.625rem -> 10px

      const gridXOffset = (offsetWidth - GRID_DIMENSION) / 2;
      const gridYOffset = (offsetHeight - GRID_DIMENSION) / 2;

      for (let i = 0; i < GRID_SIZE * GRID_SIZE; i++) {
        const row = Math.floor(i / GRID_SIZE);
        const col = i % GRID_SIZE;
        const isStructure = col < 3 || (col >= 4 && col <= 6 && row > 7) || (col > 8 && row > 5);

        newPoints.push({
          id: i,
          x: gridXOffset + (col / (GRID_SIZE - 1)) * (GRID_DIMENSION - dotSize),
          y: gridYOffset + (row / (GRID_SIZE - 1)) * (GRID_DIMENSION - dotSize),
          initialX: Math.random() * (offsetWidth - dotSize),
          initialY: Math.random() * (offsetHeight - dotSize),
          initialOpacity: Math.random() * 0.6 + 0.1,
          initialScale: Math.random() * 0.5 + 0.5,
          color: isStructure
            ? colors[Math.floor(Math.random() * colors.length)]
            : "bg-gray-400 dark:bg-gray-600",
          delay: `${Math.random() * 500}ms`,
        });
      }
      points.value = newPoints;
    }
  });
});

const getTransform = (p: Point, isHover: boolean) => {
  if (isHover) {
    return `translate(${p.x}px, ${p.y}px) scale(1)`;
  }
  return `translate(${p.initialX}px, ${p.initialY}px) scale(${p.initialScale})`;
};

const getOpacity = (p: Point, isHover: boolean) => {
  if (isHover) {
    return 1;
  }
  return p.initialOpacity;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "containerRef",
    ref: containerRef,
    class: "w-full h-full relative overflow-hidden"
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(points.value, (p) => {
      return (_openBlock(), _createElementBlock("div", {
        key: p.id,
        class: _normalizeClass(["absolute w-2.5 h-2.5 rounded-full", [p.color]]),
        style: _normalizeStyle({
        transform: getTransform(p, __props.isHovering),
        opacity: getOpacity(p, __props.isHovering),
        transition: `transform 700ms cubic-bezier(0.25, 1, 0.5, 1), opacity 700ms ease`,
        transitionDelay: p.delay,
      })
      }, null, 6))
    }), 128))
  ], 512))
}
}

})